import schema from '../../../../.changeset/schema.json';
import type { RosDashboardUpdateType } from '@/entities/ros-updates/ros-update.entity';

export const changesetTypeEmojis = schema.typeEmojis as Record<RosDashboardUpdateType, string>;
export const changesetProductLabels = schema.productSlackLabels as Record<string, string>;

export function getChangesetTypeEmoji(type: RosDashboardUpdateType): string {
  return changesetTypeEmojis[type] ?? '•';
}

export function formatChangesetProductLabels(products: string[]): string {
  return products.map((product) => changesetProductLabels[product] ?? product).join(', ');
}
